import React from 'react';
import PropTypes from "prop-types";
import {
  Overlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalText,
  ButtonGroup,
  CancelButton,
  ConfirmButton
} from './ConfirmModalStyled';
import { X } from '@phosphor-icons/react';


const ConfirmModal = ({ isOpen, title, message, onCancel, onConfirm  }) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <X size={20} onClick={onCancel} />
        </ModalHeader>
        <ModalContent>
          <ModalText>{message}</ModalText>
         
        </ModalContent>
        <ButtonGroup>
            <CancelButton onClick={onCancel}>Cancel</CancelButton>
            <ConfirmButton onClick={onConfirm}>Revoke Access</ConfirmButton>
          </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};
ConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };
export default ConfirmModal;